import { render, staticRenderFns } from "./AssignProduct.vue?vue&type=template&id=1b80dd5c&scoped=true&"
import script from "./AssignProduct.vue?vue&type=script&lang=js&"
export * from "./AssignProduct.vue?vue&type=script&lang=js&"
import style0 from "./AssignProduct.vue?vue&type=style&index=0&id=1b80dd5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80dd5c",
  null
  
)

export default component.exports